module.exports = __webpack_public_path__ + "static/media/card-back.8f689806.png";